import t from"react";const o={};export const ModalContext=t.createContext(o);export const useModalContext=()=>t.useContext(ModalContext);